import esContent from './aichat.es';

export default {
  ...esContent,
};
